<div class="status-container-small flex-row"
     [title]="isActive ? titleOn : titleOff">

  <div [ngClass]="isActive ?
        'icon-background-on white ' + iconOn :
        'icon-background-off black ' + iconOff">
  </div>

  <div [class]="isActive ? 'status-text-on' : 'status-text-off'"
       [class.status-text-small]="(isActive ? labelOn : labelOff).length > 10">
    {{ isActive ? labelOn : labelOff }}
  </div>
</div>
